import Fetcher from 'libs/fetcher';

const fetcher = new Fetcher();

export async function getUserOrgDeals() {
  return fetcher.get({
    path: '/deals/organization',
  });
}

export async function getDealById(id) {
  return fetcher.get({
    path: `/deals/${id}`,
  });
}

export async function getPublicDeal(id) {
  return fetcher.get({
    path: `/deals/${id}/public`,
  });
}

export async function createDeal(data) {
  return fetcher.post({
    path: '/deals',
    body: data,
  });
}

export async function updateDeal(id, data) {
  return fetcher.put({
    path: `/deals/${id}`,
    body: data,
  });
}

export async function createDealView(dealId, data) {
  return fetcher.put({
    path: `/deals/${dealId}/view`,
    body: data,
  });
}

export async function deleteDeal(id) {
  await fetcher.delete({
    path: '/deals',
    body: {
      id,
    },
  });
}
export const updateDealExistingInvestors = () => { /* logic */ };
